import {useEffect, useRef} from 'react';

import {SmoothingType} from '../../../../generated/graphql';
import {useDatadogRum} from '../../../../util/datadog/datadogRum';
import {SettingLevel} from '../types';

/**
 * We want to start tracking smoothing changes in Datadog RUM so we see if smoothing values cluster around certain values per smoothing type.
 */
export const useProfiledSmoothing = ({
  settingLevel,
  smoothingWeight,
  smoothingType,
}: {
  settingLevel: SettingLevel;
  smoothingWeight: number | undefined;
  smoothingType: SmoothingType | undefined;
}) => {
  const DD_RUM = useDatadogRum();
  const hasRendered = useRef(false);

  useEffect(() => {
    const action = {
      setting: 'smoothing',
      smoothingWeight,
      smoothingType,
      settingLevel,
    };
    if (hasRendered.current) {
      DD_RUM.addAction('Workspace Setting Adjusted', {
        ...action,
        initialLoad: false, // be able to distinguish changes from loaded options
      });
    } else {
      DD_RUM.addAction('Workspace Setting Adjusted', {
        ...action,
        initialLoad: true,
      });
    }

    console.log('Workspace Setting Adjusted', action);
  }, [smoothingWeight, smoothingType, settingLevel, DD_RUM]);
};
